import rasterizeHTML from 'rasterizehtml'
import { imgSrcToBlob } from 'blob-util'

export function capture (node, mime='png', {rules=[], background='#fff', margin='0', padding='0', width='100%', height="100%"}) {
  let xml = (new XMLSerializer()).serializeToString(node)
  let bg = `style="background-color: ${background}; margin: ${margin}; padding: ${padding};"`
  let forcebg = `<div style="height: ${height};width: ${width};position: absolute; top: 0;background-color: ${background};"></div>`
  let doc = `<html ${bg}><head><style type="text/css">${rules.join()}}</style></head><body ${bg}>${forcebg}${xml}</body></html>`
  return rasterizeHTML.drawHTML(doc)
    .then(result => imgSrcToBlob(result.image.src, 'image/' + mime, 'Anonymous'))
}

export function copy (node) {
  const to = node.cloneNode(true)
  copyStylesInline(to, node)
  return to
}

function copyStylesInline (destination, source) {
  if (source.nodeType === Node.ELEMENT_NODE) {
    let style = source.currentStyle || window.getComputedStyle(source)
    if (style) {
      for (let st = 0; st < style.length; st++){
        destination.style.setProperty(style[st], style.getPropertyValue(style[st]))
      }
    }
  }
  for (let cd = 0; cd < destination.childNodes.length; cd++) {
    copyStylesInline(destination.childNodes[cd], source.childNodes[cd])
  }
}

export function rules() {
  const re = /@font-face/
  let found = []
  for (let i = 0; i < document.styleSheets.length - 1; i++) {
    if (document.styleSheets[i].hasOwnProperty('cssRules')) {
      let rules = document.styleSheets[i].cssRules.values()
      let next = rules.next()
      while (!next.done) {
        if (re.test(next.value.cssText)) {
          found.push(next.value.cssText)
        }
        next = rules.next()
      }
    }
  }
  return found
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/capture.js